import { render } from "./BasicInfos.vue?vue&type=template&id=33dbb9e0&scoped=true"
import script from "./BasicInfos.vue?vue&type=script&lang=js"
export * from "./BasicInfos.vue?vue&type=script&lang=js"

import "./BasicInfos.vue?vue&type=style&index=0&id=33dbb9e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dbb9e0"]])

export default __exports__